import React, { useState, useEffect } from "react";
import axios from "axios";
import { RiArrowDownSFill, RiArrowUpSFill } from "react-icons/ri";
import { FaHistory } from "react-icons/fa";

export default function Result({ resultData }) {
  const [showModal, setShowModal] = useState(false);
  const [resultDataView, setResultData] = useState(resultData);
  const toggleModal = () => {
    setShowModal((prev) => {

      return !prev;
    });
  };
  const userId = localStorage.getItem("_id");
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const displayedData = isMobile
    ? resultData && resultData.slice(0, 5)
    : resultData && resultData.slice(0, 20);

    const resultDataLoad = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/bets/ResultList`,
          {
            userId,        // Send _id in the body
            role,       // Send role in the body
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in headers
            },
          }
        );
    
        if (response.data.success) {
          // Handle successful response, e.g., update state, render data
          setResultData(response.data.results);
        } else {
          // Handle unsuccessful response, show an error message
          console.error("Error fetching results:", response.data.message);
        }
      } catch (err) {
        console.error("Error fetching data:", err); // Log error for debugging
      }
    };
    
  const getColorClass = (crashPoint) => {
    if (crashPoint < 2) return "red";
    if (crashPoint >= 2 && crashPoint < 5) return "orange";
    if (crashPoint >= 5 && crashPoint < 10) return "green";
    return "blue";
  };
  useEffect(() => {
    resultDataLoad();
  }, []);

  return (
    <div className="result-page">
      <ul className="pl-0 resultapp">
        {displayedData.length > 0 ? (
          displayedData.map((item) => (
            <li
              className={`result ${getColorClass(item.crashPoint)}`}
              key={item.id}
            >
              <span>{item.crashPoint.toFixed(2)}X</span>
            </li>
          ))
        ) : (
          <></>
        )}
        {displayedData.length > 0 && (
          <li className="result history" onClick={toggleModal}>
            <FaHistory className="" />
            <RiArrowDownSFill className="arrowDown" />
          </li>
        )}
      </ul>
      {/* Custom Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="custom-modal full_history">
            <div className="modal-content">
              <h3 className="modal-title">
                <span>ROUND HISTORY</span>
                <button
                  className="close-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleModal();
                  }}
                >
                  <div className="result history">
                    <FaHistory className="" />
                    <RiArrowUpSFill className="arrowDown" />
                  </div>
                </button>
              </h3>

              <ul className="pl-0 resultapp1">
                {resultData.length > 0 ? (
                  resultData.slice(0, 30).map((item) => (
                    <li
                      className={`result ${getColorClass(item.crashPoint)}`}
                      key={item.id}
                    >
                      <span>{item.crashPoint.toFixed(2)}X</span>
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
